export class Permission {
    id: number;
    rol: string;
    token: string;
    errorCode: {
        message: string,
        code: string,
    };
    roles: {
        name: string,
    }[];
    users: string[];
    usersData: string[];
    windows: {
        id: number,
        name: string,
    }[];
}
